import React, { memo } from 'react';
import styled from 'styled-components';

import { getCurrentCountry } from '@front/common/src/utils/country';

import { translate } from '@front/i18n';

import Alert, { RenderProps } from '@front/web-ui/src/components/alert/alert';
import Text from '@front/web-ui/src/components/base-text/base-text';
import TextButton from '@front/web-ui/src/components/button/text-button';

import { PRO_APP_DOWNLOAD_URL_PER_COUNTRY } from '../../utils/constants';

const t = translate('screens.user_information.account_already_exists_alert_web');

const StyledAlert = styled(Alert)`
  margin-bottom: 20px;
`;

const onClick = () => {
  const country = getCurrentCountry();
  window.open(PRO_APP_DOWNLOAD_URL_PER_COUNTRY[country]);
};

const Content = (props: RenderProps) => (
  <div>
    <Text {...props}>{`${t('.text')} `}</Text>
    <TextButton type='error' onClick={onClick}>
      {t('.text_button')}
    </TextButton>
  </div>
);

type AccountAlreadyExistsAlertProps = {
  isOpen: boolean;
};

const AccountAlreadyExistsAlert = ({ isOpen }: AccountAlreadyExistsAlertProps) => {
  if (!isOpen) return null;

  return <StyledAlert type='error' title={t('.title')} content={Content} />;
};

export default memo(AccountAlreadyExistsAlert);
